function t(value){
  switch(value){
    case 'Réserver':      return 'Réserver';   break;
    case 'Nous vous contacterons au plus vite pour confirmer cette réservation.':      return 'Nous vous contacterons au plus vite pour confirmer cette réservation.<br><em>Vérifiez dans vos spams si vous n\'avez toujours pas de message d\'ici quelques jours.</em>';   break;
    
    default: return value;
  }
}
